/**
 * Configuração da API para frontend v2
 * Centraliza URLs e configurações de conexão com backend
 * Detecta automaticamente o ambiente baseado no hostname
 */

/**
 * Determina a URL base do backend baseado no ambiente atual
 * @returns {string} URL base da API
 */
function getBaseUrl () {
  const hostname = window.location.hostname

  // Produção
  if (hostname === 'equilibra.app.br' || hostname === 'www.equilibra.app.br') {
    return 'https://api.equilibra.app.br/api'
  }

  // Dev deployado (App Engine)
  if (hostname === 'dev.equilibra.app.br') {
    return 'https://api-dev.equilibra.app.br/api'
  }

  // Dev deployado (URL padrão do App Engine)
  if (hostname.includes('pwa-dot-') || hostname.includes('.appspot.com')) {
    const projectId = hostname.includes('controle-financeiro-pwa-467114')
      ? 'controle-financeiro-pwa-467114'
      : 'equilibra-prod'
    return `https://${projectId}.rj.r.appspot.com/api`
  }

  // Desenvolvimento local
  return 'http://localhost:3001/api'
}

/**
 * Configurações da API baseadas no ambiente
 */
export const API_CONFIG = {
  // URL base do backend v2 (detectada automaticamente)
  BASE_URL: getBaseUrl(),

  // Timeout padrão para requisições (30 segundos)
  TIMEOUT: 30000,

  // Configurações de retry
  RETRY: {
    attempts: 3,
    delay: 1000
  },

  // Endpoints disponíveis
  ENDPOINTS: {
    CONTAS: 'contas',
    CATEGORIAS: 'categorias',
    RESPONSAVEIS: 'responsaveis',
    TRANSACOES: 'transacoes',
    TAGS: 'tags',
    ORCAMENTOS: 'orcamentos',
    SALDOS_MENSAIS: 'saldos-mensais'
  },

  // Headers padrão
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
}

/**
 * Verifica se está em ambiente de desenvolvimento
 * @returns {boolean} True se desenvolvimento
 */
export function isDevelopment () {
  return window.location.hostname === 'localhost' ||
         window.location.hostname === '127.0.0.1'
}

/**
 * Obtém URL completa para um endpoint
 * @param {string} endpoint - Nome do endpoint
 * @returns {string} URL completa
 */
export function getEndpointUrl (endpoint) {
  return `${API_CONFIG.BASE_URL}/${endpoint}`
}
